import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';

function Header() {
  const { t, i18n } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  // Gestion de la fermeture du menu quand on clique à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setShowMenu(false);
  };

  return (
    <header
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem',
        fontFamily: 'Raleway, sans-serif',
        zIndex: 1000,
        backgroundColor: 'white',
      }}
    >
      <Link 
        to="/" 
        style={{ 
          textDecoration: 'none', 
          color: 'inherit',
        }}
      >
        <h1
          style={{
            fontSize: '2rem',
            fontWeight: 900,
            margin: 0,
            color: 'black',
            transition: 'opacity 0.2s',
            ':hover': {
              opacity: 0.8
            }
          }}
        >
          Silent.
        </h1>
      </Link>

      <div
        style={{ 
          position: 'relative', 
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}
        onClick={() => setShowMenu(!showMenu)}
        ref={menuRef}
      >
        <SettingsIcon style={{ fontSize: '1.5rem' }} />
        <ArrowDropDown style={{ fontSize: '1.2rem' }} />

        {showMenu && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              right: 0,
              backgroundColor: 'white',
              borderRadius: '4px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              minWidth: '150px',
              marginTop: '0.5rem'
            }}
          >
            <div
              style={{
                padding: '0.5rem 1rem',
                fontWeight: 600,
                borderBottom: '1px solid #eee'
              }}
            >
              {t('common:language')}
            </div>
            
            <div
              style={{
                padding: '0.5rem 0'
              }}
            >
              <div
                onClick={() => changeLanguage('en')}
                style={{
                  padding: '0.5rem 1rem',
                  cursor: 'pointer',
                  backgroundColor: i18n.language === 'en' ? '#f5f5f5' : 'transparent',
                  ':hover': {
                    backgroundColor: '#f5f5f5'
                  }
                }}
              >
                English
              </div>
              <div
                onClick={() => changeLanguage('fr')}
                style={{
                  padding: '0.5rem 1rem',
                  cursor: 'pointer',
                  backgroundColor: i18n.language === 'fr' ? '#f5f5f5' : 'transparent',
                  ':hover': {
                    backgroundColor: '#f5f5f5'
                  }
                }}
              >
                Français
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;